'use client';

import { FileText, Image as ImageIcon } from 'lucide-react';

export interface AttachmentPreviewItem {
  id: string;
  name: string;
  /** Есть только у картинок — документы показываем иконкой. */
  thumbUrl?: string;
}

interface CannyAttachmentPreviewProps {
  items: AttachmentPreviewItem[];
  onOpen?: (item: AttachmentPreviewItem) => void;
}

/**
 * Мини-превью вложений над сообщением — как в Claude.
 *
 * У картинок показываем сам кадр, у документов — иконку с именем: рендерить
 * первую страницу PDF на клиенте ради плитки 64×64 дороже, чем это стоит.
 */
export function CannyAttachmentPreview({ items, onOpen }: CannyAttachmentPreviewProps) {
  if (items.length === 0) return null;

  return (
    <div className="mb-1.5 flex flex-wrap justify-end gap-1.5">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onOpen?.(item)}
          title={item.name}
          className="group relative h-16 w-16 overflow-hidden rounded-lg border border-white/10 bg-white/[0.04] transition-transform hover:scale-[1.04] focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
        >
          {item.thumbUrl ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img src={item.thumbUrl} alt={item.name} loading="lazy" className="h-full w-full object-cover" />
          ) : (
            <span className="flex h-full flex-col items-center justify-center gap-1 px-1">
              <FileText className="h-4 w-4 text-white/40" />
              <span className="w-full truncate text-center text-[9px] leading-tight text-white/40">
                {item.name}
              </span>
            </span>
          )}
          {item.thumbUrl && (
            <span className="absolute bottom-0.5 end-0.5 flex h-4 w-4 items-center justify-center rounded bg-black/60">
              <ImageIcon className="h-2.5 w-2.5 text-white/80" />
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
